import { Button, Dialog, Spacer, Text } from '@backyard-ui/core';

import { useState } from 'react';

import styles from './BarcodeDetector.styles';
import { Scanner } from './Scanner';

interface BarcodeDetectorProps {
  inputName?: string;
  submitComponent?: string;
  showBarcodeScanner: boolean;
  setShowBarcodeScanner: (value: boolean) => void;
}

function BarcodeDetector(props: BarcodeDetectorProps) {
  const { showBarcodeScanner, setShowBarcodeScanner } = props;

  const [errorMessage, setErrorMessage] = useState('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const stopScanner = () => {
    setShowBarcodeScanner(false);
  };

  const handleScanResult = (value: string) => {
    if (value) {
      window.location.href = `/search?term=${value}&searchTerm=${value}&searchType=default`;
    }
  };

  const showError = (err: string) => {
    setErrorMessage(err);

    setIsDialogOpen(true);
  };

  const closeModal = () => {
    setIsDialogOpen(false);
    setErrorMessage('');
    setShowBarcodeScanner(false);
  };

  const handleDetection = (value: string) => {
    stopScanner();
    handleScanResult(value);
  };

  return (
    <>
      <Dialog.Root isOpen={isDialogOpen} onOpenChange={closeModal}>
        <Dialog.Content>
          <Dialog.CloseButton />
          <Dialog.Title>Erro encontrado!</Dialog.Title>
          <Dialog.Description>
            Houve um erro ao tentar capturar o código de barras, motivo:
            <Text weight="bold">- {errorMessage}</Text>
          </Dialog.Description>

          <Dialog.Close>
            <Spacer axis="vertical" size="10" />
            <Button isFullWidth>Ok</Button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Root>

      {showBarcodeScanner && (
        <div className={styles().base()}>
          <Scanner onDetected={handleDetection} showError={showError} />
          <Button
            onClick={() => setShowBarcodeScanner(false)}
            appearance="critical"
            isFullWidth
            UNSAFE_className={styles().button()}
          >
            Cancelar Scanner
          </Button>
        </div>
      )}
    </>
  );
}

export default BarcodeDetector;
